export default {
  title: 'Nebula buds AI Cuộc gọi', // "Nebula buds AI通话" 翻译为越南语
  userID: 'ID người dùng : ', // "用户ID : "
  hurryUp: 'Chờ cuộc gọi từ đối phương', // "等待对方呼叫"
  waitingCall: 'Chờ cuộc gọi từ đối phương trên trang này, vui lòng đừng đóng trang quá sớm.', // "在此页面等待对方拨打电话，请勿提前关闭。"
  subSwitch: 'Chuyển đổi phụ đề', // "字幕开关"
  initWait: 'Đang chờ khởi tạo', // "等待初始化"
  initSuccess: 'Khởi tạo thành công, chờ cuộc gọi từ đối phương. Vui lòng đừng đóng trang!', // "初始化完成，等待对方呼叫。请勿关闭页面！"
  callStart: 'Cuộc gọi đã kết nối', // "电话接通"
  callEnd: 'Cuộc gọi kết thúc', // "通话结束"
  careful: 'Lưu ý : ', // "注意 : "
  wait: 'Thành phần cuộc gọi đã sẵn sàng, chờ cuộc gọi từ đối phương', // "通话组件已准备好,等待对方拨打电话"
  langSwitch: {
    ar: 'Tiếng Ả Rập', // "阿拉伯语"
    da: 'Tiếng Đan Mạch', // "丹麦语"
    de: 'Tiếng Đức', // "德语"
    en: 'Tiếng Anh', // "英语"
    es: 'Tiếng Tây Ban Nha', // "西班牙语"
    fil: 'Tiếng Philippines', // "菲律宾语"
    fr: 'Tiếng Pháp', // "法语"
    hi: 'Tiếng Hindi', // "印地语"
    id: 'Tiếng Indonesia', // "印度尼西亚语"
    it: 'Tiếng Ý', // "意大利语"
    ja: 'Tiếng Nhật', // "日文"
    ko: 'Tiếng Hàn', // "韩语"
    ms: 'Tiếng Malay', // "马来语"
    no: 'Tiếng Na Uy', // "挪威语"
    pt: 'Tiếng Bồ Đào Nha', // "葡萄牙语"
    ru: 'Tiếng Nga', // "俄语"
    sv: 'Tiếng Thụy Điển', // "瑞典语"
    th: 'Tiếng Thái', // "泰语"
    tr: 'Tiếng Thổ Nhĩ Kỳ', // "土耳其语"
    vi: 'Tiếng Việt', // "越南语"
    zh: 'Tiếng Trung' // "中文"
  }
}
